import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiNotificationBellComponent } from './ui-notification-bell/ui-notification-bell.component';
import { UiNotificationListComponent } from './ui-notification-list/ui-notification-list.component';
import { UiNotificationItemComponent } from './ui-notification-item/ui-notification-item.component';
import { UiNotificationEmptyStateComponent } from './ui-notification-empty-state/ui-notification-empty-state.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [
    UiNotificationBellComponent,
    UiNotificationListComponent,
    UiNotificationItemComponent,
    UiNotificationEmptyStateComponent,
  ],
  exports: [
    UiNotificationBellComponent,
    UiNotificationListComponent,
    UiNotificationItemComponent,
    UiNotificationEmptyStateComponent,
  ],
})
export class NotificationsUiModule {}
